import { baseUrl, httpClient } from 'src/pages/admin/providers/AppDataProvider';

export type RewardCampaignRuleForm = {
  id?: string;
  ruleKey?: string;
  ruleName?: string;
  thresholdUsdc: string;
  rewardUsdc: string;
  sortOrder: number;
  isActive: boolean;
};

export type RewardCampaignConfigForm = {
  id: string;
  campaignId?: string;
  campaignKey: string;
  campaignType?: string;
  displayName: string;
  currency: string;
  depositThresholdUsdc: string;
  totalRewardCapUsdc: string;
  isActive: boolean;
  rules: RewardCampaignRuleForm[];
};

const RESOURCE_PATH = 'agent-reward-rules';

export async function getRewardCampaignConfig() {
  const { json } = await httpClient(`${baseUrl}/${RESOURCE_PATH}`);
  return json as RewardCampaignConfigForm;
}

export async function updateRewardCampaignConfig(
  data: RewardCampaignConfigForm,
) {
  const { json } = await httpClient(`${baseUrl}/${RESOURCE_PATH}`, {
    method: 'PUT',
    body: JSON.stringify({
      displayName: data.displayName,
      currency: data.currency,
      depositThresholdUsdc: data.depositThresholdUsdc,
      totalRewardCapUsdc: data.totalRewardCapUsdc,
      isActive: data.isActive,
      rules: data.rules.map((r) => ({
        id: r.id,
        thresholdUsdc: String(r.thresholdUsdc ?? ''),
        rewardUsdc: String(r.rewardUsdc ?? ''),
        sortOrder: Number(r.sortOrder ?? 0),
        isActive: !!r.isActive,
      })),
    }),
  });

  return json as RewardCampaignConfigForm;
}